import {useActions, useGetters, useMutators, useState} from './_default.js';
import POIPopup from "@/js/Components/MapPopup/POIPopup.vue";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        ...useState(),
        mapObjectsLoadUrl: '/payload/paginated/map/poi',
        listUrl: '/payload/paginated/sidebar/poi',

        params: { grouped: 1 },
        popupComponent: POIPopup,
    },
    getters: {
        ...useGetters(),

    },
    mutations: {
        ...useMutators(),
    },
    actions: {
        ...useActions(),
        changeActive({ state}, data) {
            return new Promise((resolve, reject) => {
                return axios.put('/poi/change-active', data).then((response) => {
                    resolve(response?.data);
                }).catch((error) => {
                    reject(error);
                })
            });
        },
    },
}